import { Dispatch, SetStateAction } from "react";
import { TrackObj } from "../../pages/MyTracks/types";

export interface MasterModalProps {
  isMasterModalOpen: boolean;
  handleMasterModalOpen: () => void;
  handleMasterModalClose: () => void;
  track: TrackObj;
  addDolbyEffect: (
    selectedPresetArray: string[],
    sliderValue: number,
    trackUrl: string,
    trackVersionId: string,
    previewStartValue: number | undefined,
    duration: number | undefined
  ) => void;
  masteredMusicUrl: string | undefined;
  handleAddTrackVersion: (
    sliderValue: number,
    selectedPreset: string,
    trackUrl: string,
    trackVersionId: string,
    isFree?:boolean
  ) => void;
  state: string;
  previewState: string;
  previewLoading: boolean;
  setPreviewLoading: Dispatch<SetStateAction<boolean>>;
  previewUrl: Map<string, string> | undefined;
  addNewVersion: (track: TrackObj) => Promise<void>;
  trackUrl: string;
  trackVersionId: string;
  setSelectedPreset: Dispatch<SetStateAction<string>>;
}

export interface DetailsProps {
  track: TrackObj;
  setPreviewStartValue: Dispatch<SetStateAction<number>>;
  setDuration: Dispatch<SetStateAction<number>>;
}

export interface MasteringBillingProps {
  handleMasterModalOpen: () => void;
  isMasterModalOpen: boolean;
  handleMasterModalClose: () => void;
}
export interface AddMasteredVersionProps {
  track: TrackObj;
  masteredMusicUrl: string | undefined;
  state: string;
  loading: boolean;
  handleAccessStage: (access: number) => void;
}

export interface ChoosePresetProps {
  selectedPresetValue: string;
  sliderValue: number;
  setSliderValue: Dispatch<SetStateAction<number>>;
  setLoading: Dispatch<SetStateAction<boolean>>;
  handleAccessStage: (access: number) => void;
  selectedPresetArray: string[];
  setSelectedPresetArray: Dispatch<SetStateAction<string[]>>;
}
export interface PreviewProps {
  track: TrackObj;
  previewUrl: Map<string, string> | undefined;
  masteredMusicUrl: string | undefined;
  selectedPresetArray: string[];
  setSelectedPresetValue: Dispatch<SetStateAction<string>>;
  loading: boolean;
  previewState: string;
  previewStartValue: number | undefined;
  duration: number | undefined;
  handleAccessStage?: (access: number) => void;
  setSelectedPreset?: Dispatch<SetStateAction<string>>;
}

export interface MasteringPresetObj {
  title: string;
  description: string;
  value: string;
  suggestedUse: string[];
}
export const navButtons = ["Details", "Presets", "Preview", "Master"];
export const MasteringPresets = [
  {
    title: "Bubbly",
    value: "a",
    description:
      "Tight dynamics and ample brightness in the upper frequencies.",
    suggestedUse: ["Pop"],
  },
  {
    title: "Oasis",
    value: "b",
    description:
      "Tight dynamics, a solid low-end, and mid-frequency clarity for vocal emphasis.",
    suggestedUse: ["Club", "EDM"],
  },
  {
    title: "Bouncy",
    value: "c",
    description: "Big bass presence and tight dynamics.",
    suggestedUse: ["Hip Hop"],
  },
  {
    title: "Thump",
    value: "d",
    description: "Heavy bass and sub-bass presence.",
    suggestedUse: ["Hip Hop"],
  },
  {
    title: "Rumble",
    value: "e",
    description:
      "Big bass and sub-bass presence with additional openness in the mid and high frequencies.",
    suggestedUse: ["Hip Hop", "Trap"],
  },
  {
    title: "Ambiance",
    value: "f",
    description: "Wide low-end processing with a light and ethereal tone.",
    suggestedUse: ["Lighter Electronic", "EDM"],
  },
  {
    title: "Crystal",
    value: "g",
    description: "Wide low-end processing with dark and moody tone.",
    suggestedUse: ["Darker Electronic", "EDM"],
  },
  {
    title: "Electric",
    value: "h",
    description:
      "Wide dynamics and ample openness in the mids and highs to allow for a wide spectrum of sound.",
    suggestedUse: ["Electronic", "EDM"],
  },
  {
    title: "Balance",
    value: "i",
    description: "Tight dynamics, and a well rounded, balanced tone.",
    suggestedUse: ["Pop", "Rock", "Country"],
  },
  {
    title: "Skyscraper",
    value: "j",
    description:
      "Smooth, tight dynamics, and a light lift in the upper frequencies.",
    suggestedUse: ["Rock", "Country"],
  },
  {
    title: "Hilltop",
    value: "k",
    description: "Wide dynamics with a solid low and mid-frequency boost.",
    suggestedUse: ["Pop"],
  },
  {
    title: "Lift",
    value: "l",
    description: "Emphasis on the mid-frequencies to highlight vocals.",
    suggestedUse: ["Vocal"],
  },
  {
    title: "Shimmer",
    value: "m",
    description:
      "Light touch with ample mid-frequency clarity to let acoustic instruments shine in the mix.",
    suggestedUse: ["Folk", "Acoustic"],
  },
  {
    title: "Subtle",
    value: "n",
    description:
      "Wide dynamics, and warm full tones for orchestral instruments.",
    suggestedUse: ["Classical"],
  },
];

export const targets = [
  {
    text: "Soundcloud",
    loudness: -13,
  },
  {
    text: "Apple",
    loudness: -16,
  },
  {
    text: "Spotify",
    loudness: -14,
  },
  {
    text: "Amazon",
    loudness: -13,
  },
  {
    text: "Youtube",
    loudness: -14,
  },
  {
    text: "Tidal",
    loudness: -14,
  },
];
